import { z } from "zod";

export const uploadFormSchema = z.object({
	email: z
  .string()
  .nonempty("Email is required")
  .email("Invalid email address")
  .max(50, "Email cannot exceed 50 characters"),
	phone: z
		.string()
		// .regex(/^\+[1-9]\d{7,14}$/, "Invalid phone number")
		.nonempty("Phone number is required")
		.max(30, "Phone number cannot exceed 30 characters"),
	fullName: z
		.string()
		// .regex(
		// 	/^\s*(?=.{2,100}$)[A-Za-z]+(?: [A-Za-z]+)*\s*$/,
		// 	"Only letters allowed"
		// )
		.max(100, "Full Name cannot exceed 100 characters")
		.nonempty("Full name is required"),
	company: z.string()
			.nonempty("Company is required")
			.max(100, "Company name cannot exceed 100 characters"),
	jobReference: z
				.string()
				.max(30, "Job reference cannot exceed 30 characters")
				.optional(),
	dueDate: z
		.preprocess((arg) => {
			// If the picker passes a Date object, convert to ISO string for validation
			if (arg instanceof Date) return arg.toISOString();
			// otherwise keep as-is (possibly string or undefined)
			return typeof arg === "string" ? arg : "";
		}, z.string())
		.superRefine((val, ctx) => {
			// presence
			if (!val || val.toString().trim().length === 0) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Due date is required",
				});
				return;
			}

			// parse
			const timestamp = Date.parse(val);
			if (isNaN(timestamp)) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Invalid due date",
				});
				return;
			}

			// compare date-only (ignore time)
			const selectedDate = new Date(timestamp);
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			selectedDate.setHours(0, 0, 0, 0);

			if (selectedDate < today) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Due date cannot be in the past",
				});
			}
		}),
	purpose: z.string().nonempty("Purpose is required"),
	description: z
		.string()
		.nonempty("Description is required")
		.max(2000, "Print instructions cannot exceed 2000 characters"),
	noofSets: z
		.string()
		.max(50, "No of sets cannot exceed 50 characters")
		.optional(),
	sizeprint: z
		.string()
		.max(50, "Size of print cannot exceed 50 characters")
		.optional(),
	ZipCode: z
		.string()
		.max(10, "ZIP code cannot exceed 10 characters")
		.optional(),

	arcaccountno: z
		.string()
		.max(50, "ARC Account number cannot exceed 50 characters")
		.optional(),

	address1: z
			.string()
			.max(200, "Address cannot exceed 200 characters")
			.optional(),
			

	willcall: z.boolean().optional(),
});

export type UploadFormSchema = z.infer<typeof uploadFormSchema>;
